import { decodeResourceIdFromUrl } from 'app/shared/utils/urlUtils';
import filterUtils from 'app/shared/utils/filterUtils';
import isEmpty from 'lodash/isEmpty';
import { loadFilterFromUrl } from 'app/shared/flux/actions/FilterActions';
import { getMarketTrends, getUnfilteredMarketTrends } from 'app/shared/flux/actions/AreaActions';
import { augmentError, formatForLog } from 'app/shared/utils/errors';

const logger = getLogger('pages/MarketTrendsResultsPage');

// @ts-ignore
const serverRouteWillMount = ({ store }) => {
  const { dispatch } = store;
  const state = store.getState();
  const pathname = state.router.location.pathname;
  const resourceId = decodeResourceIdFromUrl(pathname);
  const queryObject = state.router.location.query;
  const queryString = state.router.location.search;
  const filterParams = filterUtils.queryStringToGraphQLParams(queryString);
  const hasFilters = !isEmpty(queryObject);
  dispatch(loadFilterFromUrl(queryObject));

  if (hasFilters) {
    dispatch(getUnfilteredMarketTrends(resourceId))
      // @ts-ignore
      .catch((err) => {
        augmentError(err, {
          root: 'pages/MarketTrendsResultsPage#serverRouteWillMount',
        });

        logger.error(formatForLog(err), 'Market Stats Results Page: Error fetching Unfiltered Market Stats (SSR)');
      });
  }

  return (
    dispatch(getMarketTrends({ ...filterParams, resourceId }))
      // @ts-ignore
      .catch((err) => {
        augmentError(err, {
          root: 'pages/MarketTrendsResultsPage#serverRouteWillMount',
        });

        logger.error(formatForLog(err), 'Market Stats Results Page: Error fetching Market Stats (SSR)');

        return { changeHttpStatus: 404 };
      })
  );
};

export default serverRouteWillMount;
